import { createRoot } from 'react-dom/client';
import { App } from '@/app/bootstrap/App';
import { loadRuntimeConfig, getRuntimeConfig } from '@/shared/runtimeConfig';
import '@/shared/lib/i18n';
import './index.css';
import { StrictMode } from 'react';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

// Načteme runtime config z backendu před renderem — komponenty (MagicControlBridge,
// magicUrl helpery, phoenixOnTopConfig) ho čtou synchronně a předpokládají, že už je
// inicializovaný. Pokud fetch selže, loader vrátí prázdné defaulty a app pokračuje
// bez Phoenix-On-Top režimu.
void loadRuntimeConfig().finally(() => {
  const title = getRuntimeConfig().ui.title;
  if (title) document.title = title;

  createRoot(rootElement).render(
    <StrictMode>
      <App />
    </StrictMode>
  );
});
